import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg viewBox="0 0 22 14">
        <path
          d="M17.749 0v4.787A4.618 4.618 0 0 1 22 9.387 4.618 4.618 0 0 1 17.377 14a4.616 4.616 0 0 1-3.492-1.59H0V0h17.749zm-.372 5.515a3.875 3.875 0 0 0-3.88 3.871 3.875 3.875 0 0 0 3.88 3.872 3.875 3.875 0 0 0 3.879-3.872 3.875 3.875 0 0 0-3.88-3.87zm-.373-2.496H.743l.001 8.648h12.613a4.585 4.585 0 0 1-.603-2.28 4.618 4.618 0 0 1 4.25-4.6V3.02zm.745 3.717v2.33l2.022 1.623-.466.578-2.3-1.844V6.736h.744zM7.812 9.615v.768H2.498v-.768h5.314zM17.005.742H.744L.743 2.25h16.261V.742z"
          fill="#000"
          fillRule="nonzero"
        />
      </svg>
    </Icons>
  );
}
